import React from "react";

import { useTranslation } from "utils";

import { FOOTPRINTING_CATEGORY_COLORS } from "consts";

import {
  BeefFootprintCalculationSummary,
  CropFootprintCalculationSummary,
  DairyFootprintCalculationSummary,
  FootprintingCropEmissionsSourceCategory,
  FootprintingCropResultsDataTableRow,
  PigletFootprintCalculationSummary,
  PorkFootprintCalculationSummary,
} from "models";

import { PieChart, Typography } from "components";

export const FootprintingPieChart: React.FC<{
  footprintCalculationSummary?:
    | BeefFootprintCalculationSummary
    | CropFootprintCalculationSummary
    | DairyFootprintCalculationSummary
    | PorkFootprintCalculationSummary
    | PigletFootprintCalculationSummary;
}> = ({ footprintCalculationSummary }) => {
  const { t } = useTranslation(["footprinting"]);

  if (!footprintCalculationSummary) {
    return <Typography variant="paragraph-m">{t("resultsPage:noData")}</Typography>;
  }

  const dataWithColors = (
    Object.entries(footprintCalculationSummary.tableData) as [FootprintingCropEmissionsSourceCategory, FootprintingCropResultsDataTableRow][]
  )
    .filter(([_, row]) => row.data.totalCO2e > 0)
    .map(([category, row]) => ({
      label: t(`categories.${category}`),
      value: row.data.totalCO2e,
      color: FOOTPRINTING_CATEGORY_COLORS[category],
    }))
    .sort((a, b) => b.value - a.value);

  const pieData = dataWithColors.map((item) => ({ label: item.label, value: item.value }));
  const pieColors = dataWithColors.map((item) => item.color);

  return <PieChart data={pieData} colors={pieColors} tooltipFormatter={(_, value) => `${value?.toLocaleString()} kg CO₂e`} />;
};
